<div class="condensed-full-header-wrapper">
  <div>
    <div class="detailview-image">
      <div
        *ngIf="currentView.templateId != null"
        class="image-border"
        miq-bg-image
        [secureImage]="
          reportRecordData
            | reportFieldFormatter
              : { templateId: currentView.templateId, field: imageField, joinString: true, onlyUrl: false }
            | async
        "
      ></div>
    </div>
    <div *ngIf="additionalImageField">
      <div class="additional-image-section" *ngIf="!hasAdditionalImage; else imageBlock">
        <button mat-flat-button color="primary" class="additional-image-btn" (click)="addAdditionalImage('add')">
          <mat-icon svgIcon="add-icon"></mat-icon>
          <span l10nTranslate>template.additionalImage</span>
        </button>
      </div>
      <ng-template #imageBlock>
        <div class="detailview-image additional_image">
          <div class="actions">
            <mat-icon svgIcon="edit-icon" (click)="addAdditionalImage('edit')"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteAdditionalImage()"></mat-icon>
          </div>
          <div
            class="image-border"
            miq-bg-image
            [secureImage]="
              reportRecordData
                | reportFieldFormatter
                  : {
                      templateId: currentView.templateId,
                      field: additionalImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
          ></div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
